module.exports = __webpack_public_path__ + "img/chevron-right-16px-dark.607760e.svg";